import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withRouter from './WithRouter';
import classnames from 'classnames';
import Moment from 'react-moment';

import { addOrder, listOrders, orderActiveId } from '../actions/order';
import { SelectPicker } from 'rsuite';
import OrderAdd from './OrderAdd';
import OrderDetails from './OrderDetails';



// import Map, {Source, Layer, Popup, FullscreenControl, NavigationControl, ScaleControl, Marker} from 'react-map-gl/mapbox';
// import 'mapbox-gl/dist/mapbox-gl.css';

var z = 0


class Orders extends React.Component {

  constructor() {
      super();
      this.state = {
          name: '',
          errors: {},
          list: [],
          currentorg: '',
          showPopup: false,
          hoverInfo: false,
      }
      // this.handleInputChange = this.handleInputChange.bind(this);
      // this.handleSubmit = this.handleSubmit.bind(this);
      this.changeActiveOrder = this.changeActiveOrder.bind(this);
      this.fetchApi = this.fetchApi.bind(this);
      this.handleSortSelect = this.handleSortSelect.bind(this);
  }

  

  fetchApi(currentorg) {
    // let currentorg = localStorage.getItem('currentorg');
    this.props.listOrders(currentorg, 'name', this.props.history);
  }

  componentDidMount() {
    let og = this.props.orgcurrent.list;
    this.fetchApi(og);
    this.timeout = setInterval(() => {
        og = this.props.orgcurrent.list;
        this.fetchApi(og);
    }, 10000)
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  componentDidUpdate(prevProps) {
    // if (prevState.orderdetails !== this.state.orderdetails) {
    //     console.log('Active order has changed.')
    //     this.setState({orderdetails: prevState.orderdetails.list});
    // }

    if ( this.props.orders.list !== prevProps.orders.list ) {
        let id = this.props.orders.list[0];
        let id_old = prevProps.orders.list[0];
        if(id_old !== undefined) {
            id = id['_id'];
            id_old = id_old['_id'];
            if (id !== id_old){
                this.props.orderActiveId(id);
            }
        } else {
            if (id && id_old === undefined){
                this.props.orderActiveId(id);
            }
        }
    }
    if ( this.props.orgcurrent.list !== prevProps.orgcurrent.list ) {
        let og = this.props.orgcurrent.list;
        this.setState({currentorg: og});
        this.fetchApi(og);
    }
}





  changeActiveOrder(id) {
    this.props.orderActiveId(id);
  }
  handleSortSelect(e) {
    console.log('sort list', e);
  }
  // handleInputChange(n, v ) {
  //     this.setState({
  //         [n]: v
  //     })
  // }

  // handleSubmit(e) {
  //     e.preventDefault();
  //     const organization = {
  //         name: this.state.name,
  //         organization: localStorage.getItem('currentorg')
  //     }
  //     this.props.addOrder(organization, this.props.history);
  // }

    render() {
      const { errors } = this.state;




      return (
          <div className="component orders small-list">
            <div className="left">
              <h1>Zlecenia</h1>
              <div className="component-header">
                <div className="left">
                  <SelectPicker
                    data={[{ label: 'Nazwa', value: 'name' },{ label: 'Data', value: 'date' }]}
                    searchable={false}
                    defaultValue={'name'}
                    cleanable={false}
                    onChange={this.handleSortSelect}
                  />
                </div>
                <div className="right">
                  <OrderAdd />
                </div>
              </div>
              <ul className="list">
                {
                  this.props.orders.list.map((order, i) => (
                    <li key={order._id} className="organization">
                      <div className="left">
                        <div className="top-line">
                          <div className="name">{order.name}</div>
                          <div className="date">
                          <Moment format="DD.MM.YYYY HH:mm:ss">
                            {new Date(order.date)}
                          </Moment>
                          </div>
                        </div>
                      </div>
                      <div className="details">
                        <div className="right" onClick={() => this.changeActiveOrder(order._id)}>
                          Szczegóły
                        </div>
                      </div>
                    </li>
                  ))
                }
              </ul>
            </div>
            <div className="right">
              <OrderDetails />
            </div>
          </div>
      );
    }
}

Orders.propTypes = {
    addOrder: PropTypes.func.isRequired,
    listOrders: PropTypes.func.isRequired,
    orderActiveId: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    orders: state.orders,
    orgcurrent: state.orgcurrent,
    auth: state.auth,
    errors: state.errors,
    orderdetailsactiveid: state.orderdetailsactiveid
});

export default connect(mapStateToProps,{ addOrder, listOrders, orderActiveId })(withRouter(Orders))
